<div
  class="quotation-map-container"
  #tableContainer>
  <div class="table-container">
      <table
        mat-table
        [style.--qm-col-code]="codeColumnWidth()"
        [dataSource]="tableDataSource()"
        [trackBy]="trackByRow"
        class="quotation-table">
        <ng-container
          matColumnDef="code"
          sticky>
          <th
            class="code"
            mat-header-cell
            *matHeaderCellDef>
            Código
          </th>
          <td
            class="code"
            mat-cell
            *matCellDef="let item">
            @if (!item.isValidityRow && !item.isFooterRow) {
              {{ item.code }}
            }
          </td>
          <td
            class="code"
            mat-footer-cell
            *matFooterCellDef></td>
        </ng-container>

        <ng-container
          matColumnDef="product"
          sticky>
          <th
            class="product"
            mat-header-cell
            *matHeaderCellDef
            [attr.aria-sort]="sortAria('product')">
            <button
              type="button"
              class="col-sort-button"
              [class.col-sort-button--active]="sortDirection('product')"
              [attr.aria-label]="'Ordenar por produto'"
              (click)="toggleItemSort('product')">
              Produto
              <mat-icon aria-hidden="true">{{ sortDirection('product') === 'asc' ? 'arrow_upward' : sortDirection('product') === 'desc' ? 'arrow_downward' : 'swap_vert' }}</mat-icon>
            </button>
          </th>
          <td
            class="product"
            mat-cell
            *matCellDef="let item">
            @if (!item.isValidityRow && !item.isFooterRow) {
              <div class="product-cell-content">
                <span
                  class="product-name"
                  [aionzTooltip]="item.product"
                  mode="message"
                  >{{ item.product }}</span
                >
                @if (item.additionalInformation) {
                  <span class="product-tags">
                    <button
                      type="button"
                      class="product-tag-button"
                      [aionzTooltip]="item.additionalInformation"
                      mode="message"
                      aria-label="Informações adicionais do produto">
                      <mat-icon aria-hidden="true">info</mat-icon>
                    </button>
                  </span>
                }
              </div>
            }
            @if (item.isFooterRow) {
              <div class="footer-label-content flex-row items-center gap-8">
                @switch (item.type) {
                  @case ('freight') {
                    <span>{{ item.label }}</span>
                    <mat-icon
                      aionzTooltip="O valor do frete é único por fornecedor nesta cotação."
                      mode="message"
                      class="freight-icon"
                      >info</mat-icon
                    >
                  }
                  @default {
                    <span>{{ item.label }}</span>
                  }
                }
              </div>
            }
          </td>
          <td
            class="product"
            mat-footer-cell
            *matFooterCellDef>
            <div class="footer-label-content flex-row items-center gap-8">
              <span>TOTAL DA NEGOCIAÇÃO</span>
            </div>
          </td>
        </ng-container>

        <!-- Colunas compactáveis (Cód. ERP e Local): compactadas viram só o ícone, com o valor no tooltip. -->
        <ng-container
          matColumnDef="erp"
          sticky>
          <th
            class="erp"
            mat-header-cell
            *matHeaderCellDef
            [class.fixed-col-collapsed]="isColumnCollapsed('erp')">
            @if (isColumnCollapsed('erp')) {
              <button
                type="button"
                class="col-expand-button"
                aionzTooltip="Expandir a coluna Cód. ERP"
                mode="message"
                aria-label="Expandir a coluna Cód. ERP"
                (click)="toggleColumnCollapsed('erp')">
                <mat-icon aria-hidden="true">barcode</mat-icon>
              </button>
            } @else {
              <div class="fixed-col-header">
                <span>Cód. ERP</span>
                <button
                  type="button"
                  class="col-collapse-button"
                  aionzTooltip="Compactar a coluna"
                  mode="message"
                  aria-label="Compactar a coluna Cód. ERP"
                  (click)="toggleColumnCollapsed('erp')">
                  <mat-icon aria-hidden="true">chevron_left</mat-icon>
                </button>
              </div>
            }
          </th>
          <td
            class="erp"
            mat-cell
            *matCellDef="let item"
            [class.fixed-col-collapsed]="isColumnCollapsed('erp')">
            @if (!item.isValidityRow && !item.isFooterRow && item.ERPId) {
              @if (isColumnCollapsed('erp')) {
                <button
                  type="button"
                  class="collapsed-cell-icon"
                  [aionzTooltip]="'Cód. ERP: ' + item.ERPId"
                  mode="message"
                  [attr.aria-label]="'Código ERP ' + item.ERPId">
                  <mat-icon aria-hidden="true">barcode</mat-icon>
                </button>
              } @else {
                <span class="erp-code">{{ item.ERPId }}</span>
              }
            }
          </td>
          <td
            class="erp"
            mat-footer-cell
            *matFooterCellDef
            [class.fixed-col-collapsed]="isColumnCollapsed('erp')"></td>
        </ng-container>

        <ng-container
          matColumnDef="branch"
          sticky>
          <th
            class="branch"
            mat-header-cell
            *matHeaderCellDef
            [class.fixed-col-collapsed]="isColumnCollapsed('branch')"
            [attr.aria-sort]="sortAria('branch')">
            @if (isColumnCollapsed('branch')) {
              <button
                type="button"
                class="col-expand-button"
                aionzTooltip="Expandir a coluna Local de entrega"
                mode="message"
                aria-label="Expandir a coluna Local de entrega"
                (click)="toggleColumnCollapsed('branch')">
                <mat-icon aria-hidden="true">location_on</mat-icon>
              </button>
            } @else {
              <div class="fixed-col-header">
                <button
                  type="button"
                  class="col-sort-button"
                  [class.col-sort-button--active]="sortDirection('branch')"
                  aria-label="Ordenar por local de entrega"
                  (click)="toggleItemSort('branch')">
                  Local
                  <mat-icon aria-hidden="true">{{ sortDirection('branch') === 'asc' ? 'arrow_upward' : sortDirection('branch') === 'desc' ? 'arrow_downward' : 'swap_vert' }}</mat-icon>
                </button>
                <button
                  type="button"
                  class="col-collapse-button"
                  aionzTooltip="Compactar a coluna"
                  mode="message"
                  aria-label="Compactar a coluna Local de entrega"
                  (click)="toggleColumnCollapsed('branch')">
                  <mat-icon aria-hidden="true">chevron_left</mat-icon>
                </button>
              </div>
            }
          </th>
          <td
            class="branch"
            mat-cell
            *matCellDef="let item"
            [class.fixed-col-collapsed]="isColumnCollapsed('branch')">
            @if (!item.isValidityRow && !item.isFooterRow && item.branch) {
              @if (isColumnCollapsed('branch')) {
                <button
                  type="button"
                  class="collapsed-cell-icon branch-pin"
                  [style.color]="branchColors().get(item.branch) ?? null"
                  [aionzTooltip]="'Local de entrega: ' + item.branch"
                  mode="message"
                  [attr.aria-label]="'Local de entrega ' + item.branch">
                  <mat-icon aria-hidden="true">location_on</mat-icon>
                </button>
              } @else {
                <span
                  class="branch-cell"
                  [aionzTooltip]="'Local de entrega: ' + item.branch"
                  mode="message">
                  <mat-icon
                    aria-hidden="true"
                    [style.color]="branchColors().get(item.branch) ?? null"
                    >location_on</mat-icon
                  >
                  <span class="branch-name">{{ branchShortLabel(item.branch) }}</span>
                </span>
              }
            }
          </td>
          <td
            class="branch"
            mat-footer-cell
            *matFooterCellDef
            [class.fixed-col-collapsed]="isColumnCollapsed('branch')"></td>
        </ng-container>

        <ng-container
          matColumnDef="history"
          sticky>
          <th
            class="history"
            mat-header-cell
            *matHeaderCellDef></th>
          <td
            class="history"
            mat-cell
            *matCellDef="let item">
            @if (!item.isValidityRow && !item.isFooterRow) {
              <div class="history-cell-content">
                <button
                  type="button"
                  class="purchase-history-trigger"
                  [aionzTooltipComponent]="purchaseHistoryTooltipComponent"
                  [aionzTooltipData]="getPurchaseHistory(item)"
                  [aionzTooltipHasBackdrop]="true"
                  aionzTooltipPosition="above"
                  aionzTooltipClass="purchase-history-tooltip"
                  aria-label="Ver histórico de compra do item">
                  <mat-icon
                    class="purchase-history-icon"
                    aria-hidden="true">
                    history
                  </mat-icon>
                </button>
              </div>
            }
          </td>
          <td
            class="history"
            mat-footer-cell
            *matFooterCellDef></td>
        </ng-container>

        <ng-container
          matColumnDef="quantity"
          sticky>
          <th
            class="quantity"
            mat-header-cell
            *matHeaderCellDef>
            Qtd
          </th>
          <td
            class="quantity"
            mat-cell
            *matCellDef="let item">
            @if (!item.isValidityRow && !item.isFooterRow) {
              {{ item.quantity }}
            }
          </td>
          <td
            class="quantity"
            mat-footer-cell
            *matFooterCellDef></td>
        </ng-container>

        <ng-container
          matColumnDef="unit"
          sticky>
          <th
            class="unit"
            mat-header-cell
            *matHeaderCellDef>
            UM
          </th>
          <td
            class="unit"
            mat-cell
            *matCellDef="let item">
            @if (!item.isValidityRow && !item.isFooterRow) {
              {{ item.unit }}
            }
          </td>
          <td
            class="unit"
            mat-footer-cell
            *matFooterCellDef></td>
        </ng-container>

        @for (
          supplierId of quoteMapData().supplierIds;
          track supplierId;
          let supplierIndex = $index
        ) {
          <ng-container [matColumnDef]="supplierId">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="supplier-header supplier-column"
              [class.supplier-column-collapsed]="isSupplierHidden(supplierId)"
              [style.--qm-supplier-bg]="getSupplierHeaderColors(supplierIndex).background"
              [style.--qm-supplier-bar]="getSupplierHeaderColors(supplierIndex).bar">
              @if (isSupplierHidden(supplierId)) {
                <div class="supplier-collapsed-header">
                  <button
                    type="button"
                    class="supplier-collapse-button"
                    [aionzTooltip]="'Mostrar coluna ' + getSupplierName(supplierId)"
                    mode="message"
                    [attr.aria-label]="'Mostrar coluna ' + getSupplierName(supplierId)"
                    (click)="toggleSupplierHidden(supplierId)">
                    <mat-icon aria-hidden="true">visibility</mat-icon>
                  </button>
                  <span
                  class="supplier-collapsed-label"
                  tabindex="0"
                  [aionzTooltipComponent]="collapsedSupplierTooltipComponent"
                  [aionzTooltipData]="getCollapsedSupplierSummary(supplierId)"
                  aionzTooltipPosition="right"
                  aionzTooltipClass="collapsed-supplier-tooltip"
                  [attr.aria-label]="'Resumo da proposta de ' + getSupplierName(supplierId)"
                  >{{ getSupplierName(supplierId) }}</span
                >
                </div>
              } @else {
                <button
                  type="button"
                  class="supplier-collapse-button supplier-collapse-button--corner"
                  [class.supplier-collapse-button--locked]="
                    getSelectedProductsCount(supplierId) > 0
                  "
                  [attr.aria-disabled]="getSelectedProductsCount(supplierId) > 0"
                  [aionzTooltip]="getHideSupplierTooltip(supplierId)"
                  mode="message"
                  [attr.aria-label]="'Ocultar coluna ' + getSupplierName(supplierId)"
                  (click)="toggleSupplierHidden(supplierId)">
                  <mat-icon aria-hidden="true">{{
                    getSelectedProductsCount(supplierId) > 0 ? 'lock' : 'visibility_off'
                  }}</mat-icon>
                </button>
                <div class="supplier-info flex-col items-center justify-center">
                  <div class="supplier-name">{{ getSupplierName(supplierId) }}</div>
                  <div class="supplier-email">{{ getSupplierEmail(supplierId) }}</div>
                  @if (getSupplierRespondedAt(supplierId); as respondedAt) {
                    <div class="flex-row gap-8 items-center justify-center">
                      <mat-basic-chip class="supplier-details">
                        Respondido em: {{ respondedAt | date: 'dd/MM/yyyy' }}</mat-basic-chip
                      >
                      <button
                        mat-icon-button
                        type="button"
                        class="supplier-header-action"
                        aionzTooltip="Copiar link do fornecedor"
                        mode="message"
                        aria-label="Copiar link do fornecedor"
                        (click)="copySupplierLink(supplierId)">
                        <mat-icon aria-hidden="true">link</mat-icon>
                      </button>
                      @if (!readonly() && hasPendingSuggestedProducts(supplierId)) {
                        <button
                          mat-icon-button
                          type="button"
                          class="approve-suggested-supplier-button"
                          aionzTooltip="Aceitar todas as sugestões pendentes deste fornecedor"
                          mode="message"
                          [attr.aria-label]="'Aceitar todas as sugestões pendentes de ' + getSupplierName(supplierId)"
                          (click)="approveSuggestedSupplier(supplierId)">
                          <mat-icon aria-hidden="true">check</mat-icon>
                        </button>
                      }
                    </div>
                  } @else if (hasOnlyPendingSuggestedProducts(supplierId)) {
                    <div class="flex-row gap-8 items-center justify-center">
                      @if (isSuggestedByCotAI(supplierId)) {
                        <aionz-kanban-chip-badge
                          label="eBarn Cotai"
                          icon="auto_awesome"
                          color="var(--mat-sys-primary)"
                          tooltip="Fornecedor sugerido automaticamente pela Cotação Inteligente"
                          [compact]="true" />
                      }
                      <mat-basic-chip
                        class="supplier-pending-chip"
                        aionzTooltip="Sugestão pendente"
                        mode="message">
                        Sugestão pendente
                      </mat-basic-chip>
                      @if (!readonly()) {
                        <button
                          mat-icon-button
                          type="button"
                          class="approve-suggested-supplier-button"
                          aionzTooltip="Aceitar fornecedor sugerido"
                          mode="message"
                          aria-label="Aceitar fornecedor sugerido"
                          (click)="approveSuggestedSupplier(supplierId)">
                          <mat-icon aria-hidden="true">check</mat-icon>
                        </button>
                        <button
                          mat-icon-button
                          type="button"
                          class="delete-supplier-button"
                          aionzTooltip="Remover fornecedor da cotação"
                          mode="message"
                          aria-label="Remover fornecedor da cotação"
                          (click)="confirmDeleteSupplier(supplierId)">
                          <mat-icon aria-hidden="true">delete_outline</mat-icon>
                        </button>
                      }
                    </div>
                  } @else {
                    <div class="flex-row gap-8 items-center justify-center">
                      <mat-basic-chip class="supplier-pending-chip">
                        {{ getSupplierStatus(supplierId) }}
                      </mat-basic-chip>
                      @if (!readonly()) {
                        <button
                          mat-icon-button
                          type="button"
                          class="supplier-header-action"
                          aionzTooltip="Reenviar convite por e-mail"
                          mode="message"
                          aria-label="Reenviar convite por e-mail ao fornecedor"
                          (click)="onSendRequestEmail.emit({ supplierId })">
                          <mat-icon aria-hidden="true">forward_to_inbox</mat-icon>
                        </button>
                      }
                      <button
                        mat-icon-button
                        type="button"
                        class="supplier-header-action"
                        aionzTooltip="Copiar link do fornecedor"
                        mode="message"
                        aria-label="Copiar link do fornecedor"
                        (click)="copySupplierLink(supplierId)">
                        <mat-icon aria-hidden="true">link</mat-icon>
                      </button>
                      @if (!readonly() && hasPendingSuggestedProducts(supplierId)) {
                        <button
                          mat-icon-button
                          type="button"
                          class="approve-suggested-supplier-button"
                          aionzTooltip="Aceitar todas as sugestões pendentes deste fornecedor"
                          mode="message"
                          [attr.aria-label]="'Aceitar todas as sugestões pendentes de ' + getSupplierName(supplierId)"
                          (click)="approveSuggestedSupplier(supplierId)">
                          <mat-icon aria-hidden="true">check</mat-icon>
                        </button>
                      }
                      @if (!readonly() && canDeleteSupplier(supplierId)) {
                        <button
                          mat-icon-button
                          type="button"
                          class="delete-supplier-button"
                          aionzTooltip="Remover fornecedor da cotação"
                          mode="message"
                          aria-label="Remover fornecedor da cotação"
                          (click)="confirmDeleteSupplier(supplierId)">
                          <mat-icon aria-hidden="true">delete_outline</mat-icon>
                        </button>
                      }
                    </div>
                  }
                </div>
              }
            </th>
            <td
              mat-cell
              *matCellDef="let item"
              class="supplier-cell supplier-column"
              [class.supplier-column-collapsed]="isSupplierHidden(supplierId)"
              [class.selection-highlight]="isSelectionHighlighted(item, supplierId)">
              @if (!isSupplierHidden(supplierId)) {
                @if (getSupplierRespondedAt(supplierId); as respondedAt) {
                  @if (item.isValidityRow) {
                    @if (getSupplierValidity(supplierId); as validity) {
                      <div
                        class="validity-value"
                        [class.validity-value--expired]="getSupplierValidityStatus(supplierId) === 'expired'"
                        [class.validity-value--expiring]="getSupplierValidityStatus(supplierId) === 'expiring'"
                        [aionzTooltip]="'Validade da cotação: ' + (validity | date: 'dd/MM/yyyy')"
                        mode="message">
                        <mat-icon
                          class="validity-icon"
                          aria-hidden="true"
                          >{{ getValidityIcon(supplierId) }}</mat-icon
                        >
                        <span>{{ getValidityLabel(supplierId) }}</span>
                      </div>
                    } @else {
                      <span class="no-price">N/A</span>
                    }
                  } @else if (item.isFooterRow) {
                    @switch (item.type) {
                      @case ('observations') {
                        <div class="footer-cell-content">
                          @if (getSupplierFooterData(supplierId, item.type); as obs) {
                            <mat-icon
                              [aionzTooltip]="obs.toString()"
                              mode="message"
                              >info_outline</mat-icon
                            >
                          } @else {
                            <span
                              class="no-price"
                              aionzTooltip="O fornecedor não incluiu comentários adicionais para este item."
                              mode="message"
                              >N/A</span
                            >
                          }
                        </div>
                      }
                      @case ('freight') {
                        <div class="supplier-quote-content">
                          <div class="price-row">
                            <div
                              class="selected-price-container freight-checkbox-wrapper"
                              [class.freight-checkbox-restricted]="
                                shouldShowFreightRestriction(supplierId, 'quoted')
                              "
                              [aionzTooltip]="getFreightCheckboxTooltip(supplierId, 'quoted')"
                              mode="message"
                              [aionzTooltipDisabled]="
                                !shouldShowFreightRestriction(supplierId, 'quoted')
                              ">
                              <mat-checkbox
                                color="primary"
                                [disabled]="readonly() || !hasSelectedProducts(supplierId)"
                                [aria-label]="'Usar frete cotado de ' + getSupplierName(supplierId)"
                                [checked]="
                                  hasSelectedProducts(supplierId) &&
                                  !!getSupplierFreight(supplierId)?.selected
                                "
                                (change)="toggleFreightSelection(supplierId, $event)"
                                class="price-checkbox">
                                <div class="price-value">
                                  <span
                                    class="price-text"
                                    [class.price-text-selected]="
                                      hasSelectedProducts(supplierId) &&
                                      !!getSupplierFreight(supplierId)?.selected
                                    ">
                                    {{
                                      getSupplierFreight(supplierId)?.freight ?? 0
                                        | currency: 'BRL' : 'symbol' : '1.2-2'
                                    }}
                                  </span>
                                </div>
                              </mat-checkbox>
                            </div>

                            <div class="negotiated-price-container">
                              <div
                                class="freight-checkbox-wrapper"
                                [class.freight-checkbox-restricted]="
                                  shouldShowFreightRestriction(supplierId, 'negotiated')
                                "
                                [aionzTooltip]="getFreightCheckboxTooltip(supplierId, 'negotiated')"
                                mode="message"
                                [aionzTooltipDisabled]="
                                  !shouldShowFreightRestriction(supplierId, 'negotiated')
                                ">
                                <mat-checkbox
                                  color="primary"
                                  [disabled]="readonly() || !hasSelectedProducts(supplierId)"
                                  [aria-label]="'Usar frete negociado de ' + getSupplierName(supplierId)"
                                  [checked]="
                                    hasSelectedProducts(supplierId) &&
                                    !!getSupplierFreight(supplierId)?.negotiatedSelected
                                  "
                                  (change)="
                                    toggleNegotiatedFreight(
                                      supplierId,
                                      $event,
                                      negotiatedFreightInput
                                    )
                                  "
                                  class="negotiated-checkbox">
                                </mat-checkbox>
                              </div>

                              <mat-form-field
                                appearance="outline"
                                class="negotiated-price-field"
                                [class.negotiated-price-field--above]="isNegotiatedFreightAboveQuoted(supplierId)"
                                [style.width.px]="negotiatedFieldWidth(negotiatedFreightInput.value)"
                                subscriptSizing="dynamic"
                                [aionzTooltip]="getNegotiatedFreightTooltip(supplierId)"
                                mode="message">
                                <input
                                  matInput
                                  type="text"
                                  #negotiatedFreightInput
                                  [formControl]="getFreightFormControl(supplierId)"
                                  (input)="onNegotiatedFreightTyped(supplierId)"
                                  (keyup)="onNegotiatedFreightTyped(supplierId)"
                                  [attr.aria-label]="'Frete negociado de ' + getSupplierName(supplierId)"
                                  [attr.aria-invalid]="isNegotiatedFreightAboveQuoted(supplierId) ? 'true' : null"
                                  [disabled]="isNegotiatedFreightDisabled(supplierId)()"
                                  placeholder="R$ 0,00"
                                  mask="separator.2"
                                  separatorLimit="99999999"
                                  thousandSeparator="."
                                  decimalMarker=","
                                  prefix="R$ "
                                  step="0.01"
                                  min="0"
                                  class="negotiated-price-input" />
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      }
                      @default {
                        <div class="footer-cell-content">
                          {{ getSupplierFooterData(supplierId, item.type) }}
                        </div>
                      }
                    }
                  } @else {
                    @if (isSupplierSuggestedPending(item, supplierId)) {
                      <div class="suggested-product-actions flex-row gap-8 items-center justify-center">
                        <span
                          class="not-participating-label"
                          aionzTooltip="Sugestão pendente"
                          mode="message"
                          >Sugestão pendente</span
                        >
                        @if (!readonly()) {
                          <button
                            mat-icon-button
                            type="button"
                            class="approve-suggested-product-button"
                            aionzTooltip="Aceitar fornecedor sugerido neste produto"
                            mode="message"
                            [attr.aria-label]="'Aceitar ' + getSupplierName(supplierId) + ' para ' + item.product"
                            (click)="approveSuggestedProduct(item, supplierId)">
                            <mat-icon aria-hidden="true">check</mat-icon>
                          </button>
                          <button
                            mat-icon-button
                            type="button"
                            class="reject-suggested-product-button"
                            aionzTooltip="Recusar fornecedor sugerido neste produto"
                            mode="message"
                            [attr.aria-label]="'Recusar ' + getSupplierName(supplierId) + ' para ' + item.product"
                            (click)="rejectSuggestedProduct(item, supplierId)">
                            <mat-icon aria-hidden="true">close</mat-icon>
                          </button>
                        }
                      </div>
                    } @else if (isSupplierNotParticipating(item, supplierId)) {
                      <div class="not-participating-cell">
                        <span class="not-participating-label">Não convidado</span>
                        @if (!readonly()) {
                          <button
                            type="button"
                            class="add-quote-button"
                            aionzTooltip="Este fornecedor não foi convidado para cotar este item. Incluir envia o item para ele responder."
                            mode="message"
                            [attr.aria-label]="'Convidar ' + getSupplierName(supplierId) + ' para cotar ' + item.product"
                            (click)="addSupplierToQuotationProduct(item, supplierId)">
                            <mat-icon aria-hidden="true">person_add</mat-icon>
                            <span>Incluir</span>
                          </button>
                        }
                      </div>
                    } @else if (getQuotationMapSupplier(item, supplierId); as quote) {
                      @if (quote.price) {
                        <div class="supplier-quote-content">
                          <div class="price-row">
                            <div class="selected-price-container">
                              <mat-checkbox
                                color="primary"
                                [checked]="quote.selected"
                                [disabled]="readonly()"
                                [aria-label]="
                                  'Usar preço cotado de ' + item.product + ' com ' + getSupplierName(supplierId)
                                "
                                (change)="toggleSelection(item.code, supplierId, $event)"
                                class="price-checkbox">
                                <div class="price-value">
                                  <span
                                    class="price-text"
                                    [class.price-text-selected]="quote.selected">
                                    {{ quote.price | currency: 'BRL' : 'symbol' : '1.2-2' }}
                                  </span>
                                  @if (quote.bestPrice) {
                                    <mat-icon
                                      svgIcon="earnings"
                                      class="earnings-icon">
                                    </mat-icon>
                                  }
                                </div>
                              </mat-checkbox>
                            </div>

                            <div
                              class="negotiated-price-container"
                              [class.negotiated-price-container--above]="isNegotiatedAboveQuoted(quote)"
                              [aionzTooltip]="getNegotiatedPriceTooltip(quote)"
                              mode="message">
                              <mat-checkbox
                                color="primary"
                                [checked]="quote.negotiatedSelected"
                                [disabled]="readonly()"
                                [aria-label]="
                                  'Usar preço negociado de ' + item.product + ' com ' + getSupplierName(supplierId)
                                "
                                (change)="
                                  toggleNegotiated(item.code, supplierId, $event, negotiatedInput)
                                "
                                class="negotiated-checkbox">
                              </mat-checkbox>

                              <mat-form-field
                                appearance="outline"
                                class="negotiated-price-field"
                                [class.negotiated-price-field--above]="isNegotiatedAboveQuoted(quote)"
                                [style.width.px]="negotiatedFieldWidth(negotiatedInput.value)"
                                subscriptSizing="dynamic">
                                <input
                                  matInput
                                  type="text"
                                  #negotiatedInput
                                  [formControl]="getFormControl(item.code, supplierId)"
                                  (input)="onNegotiatedTyped(item.code, supplierId)"
                                  (keyup)="onNegotiatedTyped(item.code, supplierId)"
                                  [attr.aria-label]="
                                    'Preço negociado de ' + item.product + ' com ' + getSupplierName(supplierId)
                                  "
                                  [attr.aria-invalid]="isNegotiatedAboveQuoted(quote) ? 'true' : null"
                                  [disabled]="isNegotiatedFieldDisabled(item, supplierId)()"
                                  placeholder="R$ 0,00"
                                  mask="separator.2"
                                  separatorLimit="99999999"
                                  thousandSeparator="."
                                  decimalMarker=","
                                  prefix="R$ "
                                  step="0.01"
                                  min="0"
                                  class="negotiated-price-input" />
                              </mat-form-field>
                            </div>

                            <span
                              class="product-total"
                              [aionzTooltip]="
                                'Total do produto: ' +
                                (productTotal()(item.code, supplierId) | currency: 'BRL' : 'symbol' : '1.2-2')
                              "
                              mode="message">
                              =
                              <strong>{{
                                productTotal()(item.code, supplierId)
                                  | currency: 'BRL' : 'symbol' : '1.2-2'
                              }}</strong>
                            </span>
                          </div>
                        </div>
                      } @else {
                        <span
                        class="no-offer"
                        aionzTooltip="O fornecedor respondeu a cotação, mas não enviou preço para este item. Pode não ter o produto disponível."
                        mode="message"
                        >Sem oferta</span
                      >
                      }
                    } @else {
                      <span
                      class="no-offer"
                      aionzTooltip="O fornecedor respondeu a cotação, mas não enviou preço para este item. Pode não ter o produto disponível."
                      mode="message"
                      >Sem oferta</span
                      >
                    }
                  }
                } @else {
                  @if (
                    !item.isValidityRow &&
                    !item.isFooterRow &&
                    isSupplierSuggestedPending(item, supplierId)
                  ) {
                    <div class="suggested-product-actions flex-row gap-8 items-center justify-center">
                      <span
                        class="not-participating-label"
                        aionzTooltip="Sugestão pendente"
                        mode="message"
                        >Sugestão pendente</span
                      >
                      @if (!readonly()) {
                        <button
                          mat-icon-button
                          type="button"
                          class="approve-suggested-product-button"
                          aionzTooltip="Aceitar fornecedor sugerido neste produto"
                          mode="message"
                          [attr.aria-label]="'Aceitar ' + getSupplierName(supplierId) + ' para ' + item.product"
                          (click)="approveSuggestedProduct(item, supplierId)">
                          <mat-icon aria-hidden="true">check</mat-icon>
                        </button>
                        <button
                          mat-icon-button
                          type="button"
                          class="reject-suggested-product-button"
                          aionzTooltip="Recusar fornecedor sugerido neste produto"
                          mode="message"
                          [attr.aria-label]="'Recusar ' + getSupplierName(supplierId) + ' para ' + item.product"
                          (click)="rejectSuggestedProduct(item, supplierId)">
                          <mat-icon aria-hidden="true">close</mat-icon>
                        </button>
                      }
                    </div>
                  } @else if (
                    !item.isValidityRow &&
                    !item.isFooterRow &&
                    isSupplierNotParticipating(item, supplierId)
                  ) {
                    <div class="not-participating-cell">
                      <span class="not-participating-label">Não convidado</span>
                      @if (!readonly()) {
                        <button
                          type="button"
                          class="add-quote-button"
                          aionzTooltip="Este fornecedor não foi convidado para cotar este item. Incluir envia o item para ele responder."
                          mode="message"
                          [attr.aria-label]="'Convidar ' + getSupplierName(supplierId) + ' para cotar ' + item.product"
                          (click)="addSupplierToQuotationProduct(item, supplierId)">
                          <mat-icon aria-hidden="true">person_add</mat-icon>
                          <span>Incluir</span>
                        </button>
                      }
                    </div>
                  } @else {
                    <span
                      class="no-response"
                      aionzTooltip="Aguardando a resposta do fornecedor."
                      mode="message"
                      ><span aria-hidden="true">-</span><span class="cdk-visually-hidden">Aguardando resposta</span></span
                    >
                  }
                }
              }
            </td>
            <td
              mat-footer-cell
              *matFooterCellDef
              class="supplier-cell supplier-column"
              [class.supplier-column-collapsed]="isSupplierHidden(supplierId)">
              @if (!isSupplierHidden(supplierId)) {
                @if (getSupplierRespondedAt(supplierId)) {
                  <div class="total-negotiation-value">
                    {{ calculateSupplierTotal(supplierId) | currency: 'BRL' : 'symbol' : '1.2-2' }}
                  </div>
                } @else {
                  @if (!readonly()) {
                    <aionz-quotation-map-pending-action-button
                      [purchaseId]="quoteMapData().purchaseId"
                      [supplierId]="supplierId"
                      [supplierName]="getSupplierName(supplierId)"
                      [supplierCnpj]="getSupplierCnpj(supplierId)" />
                  }
                }
              }
            </td>
          </ng-container>
        }

        <ng-container
          matColumnDef="supplierActions"
          stickyEnd>
          <th
            mat-header-cell
            *matHeaderCellDef
            class="supplier-actions supplier-actions-header">
            <div class="supplier-actions-content">
              <!-- Dois alvos bem separados, com rótulo: antes eram ícones colados e o "Buscar"
                   (que enfileira a Cotação Inteligente) era clicado sem querer. -->
              <button
                type="button"
                class="supplier-action-button"
                aionzTooltip="Adicionar fornecedor manualmente"
                mode="message"
                aria-label="Adicionar fornecedor manualmente"
                (click)="openNewSupplierDialog()">
                <mat-icon aria-hidden="true">person_add</mat-icon>
                <span class="supplier-action-label">Adicionar</span>
              </button>
              <span
                class="supplier-actions-divider"
                aria-hidden="true"></span>
              <button
                type="button"
                class="supplier-action-button"
                [aionzTooltip]="getSupplierSearchTooltip()"
                mode="message"
                aria-label="Buscar novos fornecedores com a Cotação Inteligente"
                [disabled]="supplierSearchLoading()"
                (click)="onSearchSuppliers.emit()">
                @if (supplierSearchLoading()) {
                  <mat-progress-spinner
                    diameter="18"
                    mode="indeterminate"
                    aria-label="Buscando fornecedores" />
                } @else {
                  <mat-icon aria-hidden="true">travel_explore</mat-icon>
                }
                <span class="supplier-action-label">Buscar</span>
              </button>
              @if (supplierSearchLoading() && supplierSearchProgress(); as progress) {
                <span
                  class="supplier-search-progress"
                  role="status"
                  aria-live="polite"
                  [attr.aria-label]="progress.done + ' de ' + progress.total + ' produtos analisados'">
                  {{ progress.done }}/{{ progress.total }}
                </span>
              }
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let item"
            class="supplier-actions"></td>
          <td
            mat-footer-cell
            *matFooterCellDef
            class="supplier-actions"></td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns()"
          [class.validity-row]="row.isValidityRow"
          [class.footer-row]="row.isFooterRow"
          [class.freight-row]="row.isFooterRow && row.type === 'freight'"
          [class.product-row]="!row.isValidityRow && !row.isFooterRow"></tr>
        <tr
          mat-footer-row
          *matFooterRowDef="displayedColumns(); sticky: true"
          class="total-row footer-row"></tr>
      </table>
  </div>
</div>
